import React from 'react';
import Fadeup from '../fadeup/Fadeup';

const milestones = [
  { year: "2005", description: "Founded as a small art auction house with a passion for fine paintings." },
  { year: "2007", description: "Founded as a small art auction house with a passion for fine paintings." },
  { year: "2010", description: "Hosted our first international auction, featuring rare classical artworks." },
  { year: "2012", description: "Founded as a small art auction house with a passion for fine paintings." },
  { year: "2015", description: "Launched an online bidding platform, expanding our global reach." },
  { year: "2018", description: "Opened our first gallery space, showcasing renowned and emerging artists." },
  { year: "2020", description: "Achieved record-breaking sales in modern and contemporary art auctions." },
  { year: "2023", description: "Expanded to new locations and partnered with top collectors worldwide." },
];

function Milestones() {
  return (
    <section className="sec_pd py-5 ">
      <div className="">
       <Fadeup delay={0.3}>
       <h3 className="text-center mt-5 mb-4 mx-3 pb-2 text-black fs_40">
        Milestones
      </h3>
       </Fadeup>
       <Fadeup delay={0.2}>
       <p className="text-center mb-4 mx-3 border-bottom pb-2 text-black">
      Our journey began with a single vision: to bring together collectors and enthusiasts of art in an extraordinary space.<br /> From humble beginnings, we've established a community of connoisseurs who share a passion for the unique and the exceptional.
      </p>
       </Fadeup>
        <div className="row justify-content-center mt-5">
          {milestones.map((milestone, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-3 text-center mb-4">
              <div className="p-4 shadow rounded bg-white floral-border">
                <h3 className="fw-bold text-warning">{milestone.year}</h3>
                <p className="text-black">{milestone.description}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Milestones;
